module.exports = __webpack_public_path__ + "img/icon-app-lnd.1b9a3aa7.svg";